import { createStyles, makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() =>
	createStyles({
		root: {
			height: '70px',
		},
		margin: {
			height: '3rem',
		},
		titleWCheckbox: {
			maxWidth: 'calc( 100% - 20px)',
		},
	}),
);
